export default __webpack_public_path__ + "static/media/miguel-lopes-28.82714613.mp4";